
const rows = [
  { volume: "2.3", label: "Break Even", revenue: "£56,000", costs: "£56,000", profit: "£0", margin: "0%", highlight: false },
  { volume: "5", label: "Current Capacity", revenue: "£120,000", costs: "£81,000", profit: "£39,000", margin: "32.5%", highlight: false },
  { volume: "8", label: "Efficient", revenue: "£192,000", costs: "£110,800", profit: "£81,200", margin: "42.3%", highlight: false },
  { volume: "15", label: "Target", revenue: "£360,000", costs: "£183,000", profit: "£177,000", margin: "49.2%", highlight: true },
];

const assumptions = [
  "£2,000 average case fee",
  "£300 customer acquisition cost (CAC)",
  "Advisor: £25,000 base + 25% of case fee",
  "£8,000 operational support cost per advisor",
];

export function V2UnitEconomicsSlide({ isActive: _ }: { isActive: boolean }) {
  return (
    <div className="flex flex-col h-full">
      <div className="mb-5">
        <h2 className="text-[32px] font-light tracking-tight font-[family-name:var(--font-heading)]">
          Strong margins emerge as advisor<br />productivity increases
        </h2>
      </div>

      {/* Table */}
      <div className="overflow-x-auto mb-4">
        <table className="w-full border-collapse text-[12px]">
          <thead>
            <tr className="bg-[#818cf8] text-white text-[11px]">
              <th className="py-2 px-3 text-left font-[family-name:var(--font-mono)] font-medium uppercase tracking-wider">Volume (Cases/Mo)</th>
              <th className="py-2 px-3 text-left font-[family-name:var(--font-mono)] font-medium uppercase tracking-wider">Annual Revenue</th>
              <th className="py-2 px-3 text-left font-[family-name:var(--font-mono)] font-medium uppercase tracking-wider">Total Costs</th>
              <th className="py-2 px-3 text-left font-[family-name:var(--font-mono)] font-medium uppercase tracking-wider">Annual Profit</th>
              <th className="py-2 px-3 text-left font-[family-name:var(--font-mono)] font-medium uppercase tracking-wider">Net Margin</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr
                key={r.volume}
                className={`border-b border-[var(--color-border)] ${r.highlight ? "bg-[var(--color-surface)] font-medium" : "text-[var(--color-fg-secondary)]"}`}
              >
                <td className={`py-2 px-3 ${r.highlight ? "font-bold" : ""}`}>
                  {r.volume} ({r.label})
                </td>
                <td className={`py-2 px-3 ${r.highlight ? "font-bold" : ""}`}>{r.revenue}</td>
                <td className={`py-2 px-3 ${r.highlight ? "font-bold" : ""}`}>{r.costs}</td>
                <td className={`py-2 px-3 ${r.highlight ? "font-bold text-[#4533f7]" : ""}`}>{r.profit}</td>
                <td className={`py-2 px-3 font-bold ${r.highlight ? "text-[#4533f7]" : ""}`}>{r.margin}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Key Assumptions */}
      <div className="mb-4">
        <div className="text-[12px] font-bold text-[var(--color-accent)] mb-2">
          Key Assumptions
        </div>
        <ul className="flex flex-wrap gap-x-6 gap-y-1">
          {assumptions.map((a) => (
            <li key={a} className="flex items-center gap-2 text-[12px] text-[var(--color-fg-secondary)]">
              <span className="w-1 h-1 rounded-full bg-[var(--color-accent)] shrink-0" />
              {a}
            </li>
          ))}
        </ul>
      </div>

      <div className="text-left mt-auto mb-8 pb-4 border-b border-[var(--color-border)]">
        <p className="text-[12px] text-[var(--color-fg-secondary)] font-light">
          This is the unit we replicate with each acquisition. Each advisor at target capacity generates £177K annual profit at 49.2% margin. Average small firm: 1-2 advisors.
        </p>
        <p className="text-[12px] font-medium text-[var(--color-fg)] mt-0.5">
          10 acquired firms ≈ 15 advisors = £2.65M annual profit.
        </p>
      </div>
    </div>
  );
}
